module.exports = __webpack_public_path__ + "static/media/tdsicon.71c360a6.png";